import { FC, ReactNode, memo, useState } from 'react';
import { useResponsiveMobile } from '../../hooks';
import {
  MobileGraphFallbackAction,
  WbMobileGraphFallback,
  WbMobileGraphFallbackProps,
} from './WbMobileGraphFallback';

type WbMobileGraphGuardProps = {
  children: ReactNode;
} & WbMobileGraphFallbackProps;

/**
 * Renders children normally on desktop. On mobile, shows `WbMobileGraphFallback`
 * instead. If `secondaryAction` is provided, clicking it will also reveal
 * the children (open-anyway behaviour), in addition to calling the
 * optional onClick passed by the consumer.
 */
export const WbMobileGraphGuard: FC<WbMobileGraphGuardProps> = memo(
  function WbMobileGraphGuard({ children, secondaryAction, ...fallbackProps }) {
    const isMobile = useResponsiveMobile();
    const [openAnyway, setOpenAnyway] = useState(false);

    if (isMobile && !openAnyway) {
      const composedSecondaryAction: MobileGraphFallbackAction | undefined =
        secondaryAction
          ? {
              ...secondaryAction,
              onClick: () => {
                secondaryAction.onClick();
                setOpenAnyway(true);
              },
            }
          : undefined;

      return (
        <WbMobileGraphFallback
          {...fallbackProps}
          secondaryAction={composedSecondaryAction}
        />
      );
    }

    return <>{children}</>;
  },
);
